export const historicalSchema = [
  {
    id: 1,
    name: "Direction North",
    endpoint: "/rpc/alternative_routes?direction=north",
    xField: "hour_timestamp",
    yField: "avg_tt_paths",
    groupField: "path_name",
    axiosXLabel: "Hours",
    axiosYLabel: "Travel Time (min)",
  },
  {
    id: 2,
    name: "Direction South",
    endpoint: "/rpc/alternative_routes?direction=south",
    xField: "hour_timestamp",
    yField: "avg_tt_paths",
    groupField: "path_name",
    axiosXLabel: "Hours",
    axiosYLabel: "Travel Time (min)",
  },
  {
    id: 3,
    name: "Variability North",
    endpoint: "/rpc/historical_min_max_avg?direction=north&use_last_24h=true",
    xField: "hour_timestamp",
    yField: "value",
    groupField: "path_name",
    splitField: "value_type",
    axiosXLabel: "Hours",
    axiosYLabel: "Travel Time (min)",
  },

  {
    id: 4,
    name: "Variability South",
    // endpoint: "/rpc/historical_min_max_avg?direction=north&use_last_24h=false&target_date=2025-06-16",
    endpoint: "/rpc/historical_min_max_avg?direction=south&use_last_24h=true",
    xField: "hour_timestamp",
    yField: "value",
    groupField: "path_name",
    splitField: "value_type",
    axiosXLabel: "Hours",
    axiosYLabel: "Travel Time (min)",
  },
  // {
  //   id: 5,
  //   name: "Maximum Delay West",
  //   endpoint:
  //     "/rpc/historical_diff_max_avg_tt?direction=west&use_last_24h=true",
  //   xField: "hour_timestamp",
  //   yField: "value",
  //   groupField: "path_name",
  //   splitField: "value_type",
  //   axiosXLabel: "Hours",
  //   axiosYLabel: "Travel Time",
  // },
  // {
  //   id: 6,
  //   name: "Maximum Delay East",
  //   endpoint:
  //     "/rpc/historical_diff_max_avg_tt?direction=east&use_last_24h=true",
  //   xField: "hour_timestamp",
  //   yField: "value",
  //   groupField: "path_name",
  //   splitField: "value_type",
  //   axiosXLabel: "Hours",
  //   axiosYLabel: "Travel Time",
  // },
  // {
  //   id: 7,
  //   name: "Range West",
  //   endpoint: "/rpc/historical_diff_ranges_tt?direction=west&use_last_24h=true",
  //   xField: "hour_timestamp",
  //   yField: "value",
  //   groupField: "path_name",
  //   splitField: "value_type",
  //   axiosXLabel: "Hours",
  //   axiosYLabel: "Travel Time",
  // },
  // {
  //   id: 8,
  //   name: "Range East",
  //   endpoint: "/rpc/historical_diff_ranges_tt?direction=east&use_last_24h=true",
  //   xField: "hour_timestamp",
  //   yField: "value",
  //   groupField: "path_name",
  //   splitField: "value_type",
  //   axiosXLabel: "Hours",
  //   axiosYLabel: "Travel Time",
  // },
];
